import { ReactElement, ReactNode, Suspense } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { userInfoState } from 'recoil/user/atom';
import { ROLE_TYPE } from 'types/enumType';
import { decryptString } from 'util/encryptUtil';

interface AuthGuardProps {
  children: ReactNode;
}

const getNavigateAfterCheckLogin = (
  url: string,
  isAuthenticated: boolean,
): ReactElement | null => {
  if (isAuthenticated) {
    if (url === '/sign-in' || url === '/sign-up' || url === '/') {
      return <Navigate to={'/home/status-board'} replace />;
    }
  } else {
    if (!(url === '/sign-in' || url === '/sign-up')) {
      return <Navigate to={'/sign-in'} />;
    }

    return null;
  }

  return null;
};

const getNavigateAfterCheckAuthority = (
  url: string,
  role: string,
): ReactElement | null => {
  if (url.startsWith('/admin') && role !== ROLE_TYPE.ADMIN) {
    alert('접근 권한이 없습니다.');
    return <Navigate to={'/home/status-board'} replace />;
  }

  if (
    (url.includes('/self-permission') ||
      url.includes('/permission-transfer') ||
      url.includes('/box')) &&
    role === ROLE_TYPE.USER
  ) {
    alert('접근 권한이 없습니다.');
    return <Navigate to={'/home/status-board'} replace />;
  }

  return null;
};

const AuthGuard = ({ children }: AuthGuardProps) => {
  const userInfo = useRecoilValue(userInfoState);

  const role = decryptString(userInfo.role);
  const location = useLocation();

  if (!role) {
    alert('권한에 변경이 생겨 로그아웃 됩니다.\n다시 로그인 해주세요');
    sessionStorage.clear();
    return <Navigate to={'/sign-in'} />;
  }

  const url = location.pathname;

  const navigateElement =
    getNavigateAfterCheckLogin(url, userInfo.isAuthenticated) ||
    getNavigateAfterCheckAuthority(url, role);
  if (navigateElement) {
    return navigateElement;
  }

  return <Suspense>{children}</Suspense>;
};

export default AuthGuard;
